import styled from 'styled-components';
import { getBaseTheme } from '@Themes';
import { textblocks } from 'seal-ui-components';

export const ShowMoreItemWrapper = styled.div`
    background-color: ${getBaseTheme().colors.area.default.backgroundColor};
    margin-bottom: ${getBaseTheme().sizes.xxxs};
    font-size: ${getBaseTheme().texts.sizes.xs.fontSize};
    line-height: ${getBaseTheme().texts.sizes.xs.lineHeight};
    padding: ${getBaseTheme().spaces.insetSquish.xs};

    :hover {
        cursor: pointer;
        background-color: ${getBaseTheme().colors.control.hover.backgroundColor};
    }

    :active {
        background-color: ${getBaseTheme().colors.control.active.backgroundColor};
    }
`;
export const CenterWrapper = styled(textblocks.Heading4)`
    text-align: center;
    cursor: pointer;
`;
